import { useState } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { Button, Text, Stack, Container, Paper, Group, TextInput } from '@mantine/core';
import { Constants, border, colors } from '../constants';

const NameDesignModalMobile = ({ isOpen, onClose, onSubmit, onSkip }) => {
  const [designName, setDesignName] = useState('');

  const handleDesignNameChange = (event) => {
    setDesignName(event.target.value);
  };

  const handleSubmit = () => {
    if (designName.trim()) {
      onSubmit(designName.trim());
    }
    setDesignName('');
    onClose();
  };

  const handleSkip = () => {
    setDesignName('');
    onSkip();
    onClose();
  };

  const mobileModalStyle = Constants.components.modal.mobileStyle;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel='Name Your Design?'
      style={mobileModalStyle}
    >
      <Paper
        shadow="xl"
        radius="15px"
        p="xl"
        style={{
          backgroundColor: colors.backgroundLight,
          border: `10px solid ${colors.primary}`,
        }}
      >
        <Stack spacing="lg" align="center">
          <Text
            size="xl"
            weight={700}
            align="center"
            style={{
              color: colors.white,
              fontSize: Constants.fontSize.xl,
              lineHeight: '1.2',
              marginBottom: '10px',
            }}
          >
            Would you like to name your garden design?
          </Text>

          <Container size="sm" px={0}>
            <TextInput
              type="text"
              value={designName}
              onChange={handleDesignNameChange}
              placeholder="i.e. Front Yard 1"
              size="lg"
              radius="md"
            />
          </Container>

          <Group spacing="md" w="100%" grow>
            <Button
              onClick={handleSkip}
              size="lg"
              variant="outline"
              style={{
                border: `2px solid ${colors.primary}`,
                borderRadius: Constants.borderRadius.medium,
                height: Constants.dimensions.buttonHeight,
                fontSize: Constants.fontSize.lg,
                fontWeight: 'bold',
                color: colors.primary,
                backgroundColor: 'transparent',
              }}
            >
              Skip
            </Button>

            <Button
              onClick={handleSubmit}
              size="lg"
              style={{
                backgroundColor: colors.primary,
                border: 'none',
                borderRadius: Constants.borderRadius.medium,
                height: Constants.dimensions.buttonHeight,
                fontSize: Constants.fontSize.lg,
                fontWeight: 'bold',
                color: colors.white,
              }}
              disabled={!designName.trim()}
            >
              Submit
            </Button>
          </Group>
        </Stack>
      </Paper>
    </Modal>
  );
};

NameDesignModalMobile.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
};

export default NameDesignModalMobile;
